<template>
  <div class="pop" ref="pop" :style="{display: isshow}">
    <div class="popbox">
      <h2 v-if="isapprove">您的留言已提交审核</h2>
      <h2 v-else>您的留言已提交</h2>
      <span @click.stop="confirm">完成</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tipcommon',
  props: ['popIsshow', 'isapprove'],
  data () {
    return {
      timers: null,
      isshow: 'none'
    }
  },
  watch: {
    popIsshow (val) {
      console.log(val)
      this.isshow = val
    }
  },
  methods: {
    confirm () {
      this.isshow = 'none'
      this.timers = setInterval(() => {
        if (this.$cookie.get('typeflag') === 'false') {
          this.$router.push({path: '/mymessage', query: {museumCode: this.$cookie.get('museumCode'), typeflag: 1, theme: this.$cookie.get('themeName')}})
        } else {
          this.$router.push({path: '/mymessage', query: {museumCode: this.$cookie.get('museumCode'), theme: this.$cookie.get('themeName')}})
        }
      }, 300)
    }
  },
  beforeDestroy () {
    clearInterval(this.timers)
    this.timers = null
  }
}
</script>

<style lang="scss">
.pop{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0,0,0,0.4);
  .popbox{
    width: 20%;
    height: 140px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -70px 0 0 -10%;
    background: #fff;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    overflow: hidden;
    padding: 40px 20px 0;
    text-align: center;
    h2{
      font-size: 14px;
      text-align: center;
      margin: 0 0 20px;
    }
    span{
      display: inline-block;
      width: 60%;
      height: 36px;
      line-height: 36px;
      background: #a11b00;
      text-align: center;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      border-radius: 4px;
      color:#fff;
    }
  }
}

@media only screen and ( max-width:768px) {
  .pop{
    .popbox{
      width: 60%;
      margin-left: -30%;
    }
  }
}
.lstheme{
  .pop{
    .popbox{
      background: #012245;
      border: solid 1px #9fb9d0;
      box-shadow: 0 0 40px rgba(171, 222, 254, 0.5) inset;
      h2{
        color: #fff;
      }
      span{
        border: solid 2px #5297f2;
        border-radius: 20px;
        background: -webkit-linear-gradient(top, #fefefe , #7cbbee);
        background: -o-linear-gradient(bottom, #fefefe, #7cbbee);
        background: -moz-linear-gradient(bottom, #fefefe, #7cbbee);
        background: linear-gradient(to bottom, #fefefe , #7cbbee);
        filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#fefefe, endColorstr=#7cbbee);
        color: #123764;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/tipcommon.vue